import React, { useEffect, useState } from 'react';
import { Container, Navbar, Offcanvas } from 'react-bootstrap';

export const CommonHamburgar = ({ children }: any) => {

    const [expand, setExpand] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 787) {
                setExpand(false);
            }
        }
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <Navbar expand="md" bg='light' className='common_hamburgar_mobile'>
            <Container style={{ padding: '0' }}>
                <Navbar.Toggle aria-controls={`basic-navbar-nav`} className='border-0' />
                <Navbar.Offcanvas
                    id={`offcanvasNavbar-expand-${expand}`}
                    aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                    placement="start"
                >
                    <Offcanvas.Header closeButton>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className='common_hamburbar_mobile-content'>
                            {children}
                        </div>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>)
}